import React, {
    useContext
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import messages from './SgRenewalAddonSummary.messages';

function SgRenewalAddonSummary(props) {
    const {
        renewalDetails
    } = props;

    const LEVEL_OF_COVER_TERM_NAME = 'Level of Cover';
    const translator = useContext(TranslatorContext);
    const selectedCoverages = renewalDetails.availableCoverages.filter((cov) => cov.selected);
    const unselectedCoverages = renewalDetails.availableCoverages.filter((cov) => !cov.selected);

    return (
        <div>
            { selectedCoverages.length > 0
                && (
                    <div className="sgPolicyInfo">
                        <div className="sgPolicyInfoName">{translator(messages.IncludedLabel)}</div>
                        <div className="sgPolicyInfoValue">
                            {selectedCoverages.map((cov, index) => {
                                const selectedCoverageContainerKey = `selectedCoverage_${index}_container`;
                                return (
                                    <div key={selectedCoverageContainerKey}>
                                        <span
                                            id={`coverage_${cov.patternCode}`}
                                        >
                                            {cov.name}
                                        </span>
                                        {cov.terms.map((term, termIndex) => {
                                            const termContainerKey = `term_${termIndex}_container`;
                                            return (
                                                term.name !== LEVEL_OF_COVER_TERM_NAME
                                            && (
                                                <ul key={termContainerKey}>
                                                    <li>
                                                        <span id={term.name}>
                                                            {term.name}
                                                        </span>
                                                        {term.value != null
                                                            && (
                                                                <span
                                                                    id={`${term.name}Value`}
                                                                >
                                                                    {` - ${term.value}`}
                                                                </span>
                                                            )
                                                        }
                                                    </li>
                                                </ul>
                                            )
                                            );
                                        })}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )
            }
            {unselectedCoverages.length > 0
                && (
                    <div className="sgPolicyInfo">
                        <div className="sgPolicyInfoName">{translator(messages.NotIncludedLabel)}</div>
                        <div className="sgPolicyInfoValue">
                            {unselectedCoverages.map((cov, index) => {
                                const unselectedCoverageContainerKey = `unselectedCoverage_${index}_container`;
                                return (
                                    <div key={unselectedCoverageContainerKey} id={`coverage_${cov.patternCode}`}>{cov.name}</div>
                                );
                            })}
                        </div>
                    </div>
                )
            }
        </div>
    );
}

export default SgRenewalAddonSummary;
